import { IconUsers, Text } from '@vtex/admin-ui'
import { useIntl } from 'react-intl'
import type { Cluster } from 'typings'
import { Tag, TagsList } from '../../../Tag'
import {
  Rule,
  RuleActions,
  RuleContent,
  RuleDescription,
  RuleIcon,
} from '../../RuleStack'
import { RuleDefaultActions } from '../../RuleStack/DefaultActions'
import { messages } from './messages'

type Props = {
  config: Cluster | undefined
  onEdit: () => void
  onRemove: () => void
}

export function ClusterView(props: Props) {
  const { config, onEdit, onRemove } = props
  const { formatMessage: i18n } = useIntl()

  if (!config) return

  const { operator, expressions } = config

  return (
    <Rule onClick={onEdit}>
      <RuleIcon>
        <IconUsers />
      </RuleIcon>

      <RuleDescription>
        {i18n(
          messages.view.title,
          {
            b: (content: React.ReactNode) => (
              <Text variant="body">{content}</Text>
            ),
            count: expressions.length,
            operator,
          },
          { requiresOtherClause: false }
        )}
      </RuleDescription>

      <RuleContent>
        <TagsList>
          {expressions.map((expression, index) => (
            <Tag key={index}>{expression}</Tag>
          ))}
        </TagsList>
      </RuleContent>

      <RuleActions>
        <RuleDefaultActions onEdit={onEdit} onRemove={onRemove} />
      </RuleActions>
    </Rule>
  )
}
